<div
    class="sidebar-area bg-white active my-4 rounded-4"
    [ngClass]="{'active': isSidebarToggled}"
    [class.component-dark-theme]="themeService.isDark()"
    [class.dark-sidebar]="themeService.isSidebarDark()"
    [class.right-sidebar]="themeService.isRightSidebar()"
    [class.hide-sidebar]="themeService.isHideSidebar()"
    [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <div class="logo bg-white">
        <a routerLink="/" class="d-flex align-items-center">
            <img src="assets/images/logo-icon.svg" alt="logo-icon">
            <span class="fw-semibold"> iLAB</span>
        </a>
    </div>
    <div
        (click)="toggle()"
        class="burger-menu"
        [ngClass]="{'active': isSidebarToggled}"
    >
        <span class="top-bar"></span>
        <span class="middle-bar"></span>
        <span class="bottom-bar"></span>
    </div>
    <ng-scrollbar visibility="hover">
        <div class="sidebar-inner">
            <div class="sidebar-menu">

                <mat-accordion>
                    <a routerLink="/" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <i class="material-symbols-outlined">dashboard</i>
                        <span class="title">Tableau de board</span>
                    </a>

                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="material-symbols-outlined">group</i>
                                <span class="title">Clients</span>
                                <span class="daxa-badge">{{totalClients}}</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/manage-clients" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Liste des clients
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/manage-clients-poc" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Liste des contacts
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/manage-clients-exploitation" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Liste des exploitations
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/manage-terrain" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Liste des terrains
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>
                    <a routerLink="/propals" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <i class="material-symbols-outlined">order_approve</i>
                        <span class="title">Devis</span>
                    </a>

                    <a routerLink="/bdc" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <i class="material-symbols-outlined">order_approve</i>
                        <span class="title">Bons de commande</span>
                    </a>

                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <i class="material-symbols-outlined">Science</i>
                            <span class="title">Échantillons</span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                      
                        <ul class="sidebar-sub-menu">
                          <li class="sidemenu-item">
                            <a routerLink="/manage-prelevemnt" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                Prélèvements
                            </a>
                        </li>   
                        <!--<li class="sidemenu-item">
                            <a routerLink="/manage-reception" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                Réception
                            </a>
                        </li> -->
                        <li class="sidemenu-item">
                            <a routerLink="/manage-samplers" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                              Échantillons
                            </a>
                          </li>                      
                        </ul>
                      </mat-expansion-panel>
                      
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="material-symbols-outlined">Troubleshoot</i>
                                <span class="title">Resultats</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/In-Progress-Analyses-Component" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    En cours
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/calculated-analyses-compo" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Calculé
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/validated-analyses-compo" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Validé
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>
    
                    <!--<a routerLink="/fiche-paillasse" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <i class="material-symbols-outlined">data_table</i>
                        <span class="title">Fiche de paillasse</span>
                    </a>-->

                    <a routerLink="/report" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <i class="material-symbols-outlined"> print </i>
                        <span class="title">Rapports</span>
                    </a>
                    <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="material-symbols-outlined">inventory</i>
                                <span class="title">Stock</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/manage-produit" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Produit
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/manage-emplacement" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Emplacement
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/manage-mouvement" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Mouvement de stock
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/manage-fournisseur" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Fournissuer
                                </a>
                            </li>
                        </ul>  
                    </mat-expansion-panel>
                    <mat-expansion-panel  *ngIf="isAdmin" (opened)="panelOpenState = true" (closed)="panelOpenState = true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="material-symbols-outlined">Manufacturing</i>
                                <span class="title">Parameters</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/manage-users" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Users
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/manage-parameter" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Parameters d'analyse
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/manage-matrice" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Matrice
                                </a>
                            </li>

                            <li class="sidemenu-item">
                                <a routerLink="/methode" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Méthode
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/manage-type-analyse" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Type d'analyse
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/manage-labo" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Laboratoire
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/manage-acc" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Accreditation
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/manage-actSub" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    ActiveSubstance
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>
                </mat-accordion>

            </div>
        </div>
    </ng-scrollbar>
</div>
